<Modal
    role="alertdialog"
    {body}
    {heading}
    {id}
    on:modalClosed
>
    <div slot="body" class="prom-modal__body-container">
        <slot></slot>
    </div>

    <div slot="footer" class="prom-modal__button-container">
        <Button
            type={destructive ? 'destructive' : 'primary'}
            large={true}
            text={translations.CONFIRM}
            on:click={confirm}
        />

        <Button
            type="secondary"
            large={true}
            text={translations.CANCEL}
            on:click={cancel}
        />
    </div>
</Modal>

<script>
    import Button from '../../../inputs/Button/v1/Button.svelte';
    import Modal from '../../Modal/v1/Modal.svelte';
    import ModalEvent from '../../Modal/v1/ModalEvents';

    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    const defaultI18n = {
        CONFIRM: 'Confirm',
        CANCEL: 'Cancel'
    };

    /**
     * The translation property.
     * @type {Object}
     */
    export let i18n = {};
    /**
     * The title of the modal, displayed as a heading tag.
     * @type {string}
     */
    export let heading = '';
    /**
     * The content of the modal, i.e. message.
     * @type {string}
     */
    export let body = '';
    /**
     * Should we style the buttons to show that this is destructive?
     * @type {boolean}
     */
    export let destructive = false;
    /**
     * The identifier property.
     * @type {string}
     */
    export let id = 'prom-confirm';
    
    /**
     * @param {Event}
     */
    function confirm(event) {
        dispatch(ModalEvent.CONFIRMED, { event });
    }

    /**
     * @param {Event}
     */
     function cancel(event) {
        dispatch(ModalEvent.CANCELLED, { event });
    }

    $: translations = { ...defaultI18n, ...i18n };
</script>
